import { Component, Inject, OnInit, OnDestroy, Injectable } from '@angular/core';
import { DwAction, DwActionType, DwButtonType, DwActionHandler, DwMdFormActionState,
         DwActionResult, DwConfigServiceToken, DwConfigService, 
         DwRoutingService} from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../meta-data/app-meta-data.service';
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map, mergeMap } from 'rxjs/operators';
import { PaymentParty } from '../models/payment-party.enum';

@DwAction({
    keyName: 'customerPortalView',
    display: 'Customer Portal View',
    actionType: DwActionType.formAction,
    isGlobal: false,
    parentItemName: [ AppMetaDataItemNames.FlightSchool, AppMetaDataItemNames.DwUser ],
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'View Invoices',
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-secondary',
        iconClass: 'fa fa-file-invoice-dollar',
    },
})

@DwAction({
    keyName: 'customerPortalView-Grid',
    display: 'Customer Portal View',
    actionType: DwActionType.gridAction,
    isGlobal: false,
    parentItemName: [ AppMetaDataItemNames.RoSchoolPaymentMethod, AppMetaDataItemNames.RoStudentPaymentMethod],
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'View Invoices',
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-secondary',
        iconClass: 'fa fa-file-invoice-dollar',
    },
})
@Injectable()
export class CustomerPortalViewActionService implements DwActionHandler {
    paymentsApi: string;
    constructor(
        private http: HttpClient,
        private dwRoutingService: DwRoutingService,
        @Inject(DwConfigServiceToken) private configService: DwConfigService) 
    { 
        this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
    }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        const isSchoolSettingsPage = this.dwRoutingService.currentPageUrl.indexOf('/setting') >= 0;


        const target = isSchoolSettingsPage ? PaymentParty.FlightSchool : PaymentParty.Student;

        return this.http.get<PortalLink>(`${this.paymentsApi}/customer-portal/${target}`)
                    .pipe(mergeMap(link => {
                        if (link.success)
                            window.open(link.Url, '_portal');
                        return of({ success: link.success });
                    }));
    }
}
export interface PortalLink {
    success: boolean,
    Url: string
}
  